"use client";

import { c as _c } from "react/compiler-runtime";
import type { ApiProfileMin } from "@/generated/models/ApiProfileMin";
import { createContext, type ReactNode, useContext, useMemo } from "react";
type QuoteAuthorIdentity = Pick<ApiProfileMin, "handle" | "id" | "primary_address">;
type WaveDropQuoteDisplayContextValue = {
  readonly flattenWhenAuthorSameAs: QuoteAuthorIdentity | null;
};
const WaveDropQuoteDisplayContext = createContext<WaveDropQuoteDisplayContextValue>({
  flattenWhenAuthorSameAs: null
});
export function WaveDropQuoteDisplayProvider(t0) {
  const $ = _c(5);
  const {
    children,
    flattenWhenAuthorSameAs
  } = t0;
  let t1;
  if ($[0] !== flattenWhenAuthorSameAs) {
    t1 = {
      flattenWhenAuthorSameAs
    };
    $[0] = flattenWhenAuthorSameAs;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const value = t1;
  let t2;
  if ($[2] !== children || $[3] !== value) {
    t2 = <WaveDropQuoteDisplayContext.Provider value={value}>{children}</WaveDropQuoteDisplayContext.Provider>;
    $[2] = children;
    $[3] = value;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
export const useWaveDropQuoteDisplay = () => {
  return useContext(WaveDropQuoteDisplayContext);
};